<div class="container pt-5 panel panel-success">
    <div class="panel-heading">
        <h1 class="fs-2 py-3">Email Delivery Status</h1>
    </div>
    <div class="panel-body">
        <p>We sent {{details?.emailsSent}} emails to your email inbox, it may take a couple of minutes before they appear.</p>
        <p><strong>Please check that you got them, and click on the link in each one of them</strong>.</p>
        <p>Contact us at <a href="mailto:support@teammood.com">support&#64;teammood.com</a> if you got none.</p>

    <div class="text-end">
        <button type="button" class="btn btn-default" (click)="loadStatus()"><i class="far fa-sync"></i></button>
    </div>

    <p class="pb-2">Here is the report so far after sending {{details?.emailsSent}} test emails:</p>

    <table class="table table-bordered">
        <colgroup>
            <col style="width: 20%">
            <col style="width: 80%">
        </colgroup>
        <thead>
        <tr>
            <th>Provider Id</th>
            <th>Events</th>
        </tr>
        </thead>
        <tbody>
        @for(event of status; track event.id){
        <tr>
            <td>{{event.id}}</td>
            <td>
                <span class="badge me-1" [ngClass]="event.sent? 'text-bg-success':'text-bg-danger'">sent</span>
                <span class="badge" [ngClass]="event.clicked? 'text-bg-success':'text-bg-danger'">clicked</span>
            </td>
        </tr>
        }
        </tbody>
    </table>

    <p class="pb-2">Details are provided below.</p>
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>Email Id</th>
                <th>Provider Id</th>
                <th>Date</th>
                <th>Event</th>
            </tr>
        </thead>
        <tbody>
            @for(event of (details?.events); track event.id){
            <tr>
                <td>{{event.messageId}}</td>
                <td>{{event.id}}</td>
                <td>{{event.date}}</td>
                <td>{{event.status}}</td>
            </tr>
            }
        </tbody>
    </table>

    </div>
</div>